import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
  const [isChecking, setIsChecking] = useState(true);
  const user = useSelector((state) => state?.superAdmin?.user);

  useEffect(() => {
    // Give Redux a moment to hydrate the state
    const checkAuth = setTimeout(() => {
      setIsChecking(false);
    }, 100);

    return () => clearTimeout(checkAuth);
  }, []);

  // Don't render anything while checking authentication
  if (isChecking) {
    return null; // Or return a loading spinner if preferred
  }

  // Once checked, handle routing
  if (user) {
    return user?.admintype === "Admin" || user?.admintype === "OrganizationAdmin" || user?.admintype === "IndividualAdmin" ? (
      <Navigate to="/user" replace />
    ) : (
      <Navigate to="/admin" replace />
    );
  }

  return children;
};

export default PublicRoute;